var captInMiliSecond = 60000;
var queryCount = 3;
var expiredTimeDedault = (3*60*60*1000); // 3 hours

function setCookie(name,value,days) {
    var expires = "";
    if (days != undefined && days != null) {
        var date = new Date();       
        if(days <= 0){
          date.setTime(date.getTime() + expiredTimeDedault);//(3*60*60*1000)
        }else{
        	date.setTime(date.getTime() + (days*24*60*60*1000));
        }
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function setCookieMinutes(name,value,minutes) {
    var expires = "";
    if (minutes != undefined && minutes != null) {
        var date = new Date();       
        if(minutes > 0){
          date.setTime(date.getTime() + (minutes*60*1000));
        }
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function parseToInt(value){
  if(value != null && value != undefined && value != ""){
  	return parseInt(value);
  }
  return 0;
}

function isMobile(){
	return ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) );
   
}

function isAndroid() {
  const userAgent = navigator.userAgent;
  return (/android/i.test(userAgent));
  
}


function isIOS() {
  const userAgent = navigator.userAgent;    
  return (/iPad|iPhone|iPod/i.test(userAgent));
}

function gotoTabContent(viewId){   
    var elementTarget = document.getElementById(viewId);
    if(elementTarget){        
        const topPosition = elementTarget.offsetTop;
        window.scrollTo({
            top: topPosition,
            behavior: 'smooth'
        });
    }
}